module.exports = __webpack_public_path__ + "static/media/Sound_16370.15a34614.mp3";